import client from './core/client';

/** Endpoints */
import form from './endpoints/form';
import banks from './endpoints/banks';
import advisers from './endpoints/advisers';
import token from './endpoints/token';
import politicalDivisions from './endpoints/politicalDivisions';
import propertyTypes from './endpoints/propertyTypes';

export default {
  form,
  banks,
  token,
  politicalDivisions,
  propertyTypes,
  advisers,
  headers: client.headers,
};
